// 16 位的随机数
const characters = 'abcdef0123456789'
const charactersLength = 16

export function generateTraceId() {
  let result = ''

  for (let i = 0; i < 16; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }

  return result
}

export const TRACE_HEADER_NAME = 'x-b3-traceid'

export const DEFAULT_TRACE_HOST_LIST = ['www.xiaohongshu.com', 'logan.devops.xiaohongshu.com', 'dragon.devops.xiaohongshu.com']
